module.exports = __webpack_public_path__ + "media/images/banner/tjt/pc/travel06_770_280_vi-a8881bc7e38989dcf66d648d86623cca.jpg";